<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <form *ngIf="criminalHistoryData ;  else loading" [formGroup]="criminalHistoryForm" (ngSubmit)="onSubmit()">

    <div *ngFor="let type of this.questions_Category">
      <h1 class="bofa--heading is-4">{{type}} Questions</h1>
      <div *ngFor="let data of this.getQuestionsbasedCategory(type); let i=index" [formGroup]="data">
        <div #item>
          <span class="minor-list-space" id="await-trial-label"><abbr title="required">*
            </abbr>{{data.controls.questions.value}}</span>
          <mat-radio-group aria-describedby="await-trial-label" formControlName="answer" required
            class="bottom-space minor-radio-padding radio-flex">
            <mat-radio-button class="minor-list-space radio-padding field-space" value=1 name="answer">Yes
            </mat-radio-button>
            <mat-radio-button value=0 class="field-space" name="answer">No</mat-radio-button>
          </mat-radio-group>
          <div *ngIf="data.controls.answer.value == '1'">
            <mat-form-field class="max-zoom field-space non-required" *ngIf="this.criminalHistoryData.jobCountryId != 78">
              <mat-label>Please provide description</mat-label>
              <input matInput formControlName="description" maxlength="150">
            </mat-form-field>
            <mat-form-field class="max-zoom field-space non-required-ous" *ngIf="this.criminalHistoryData.jobCountryId == 78 && data.controls.question_id.value==53">
              <mat-label>Please provide description and upload Court Order and Court Room Check (CRC) on the Certification Tab</mat-label>
              <input matInput formControlName="description" maxlength="150">
            </mat-form-field>
            <mat-form-field class="max-zoom field-space non-required" *ngIf="this.criminalHistoryData.jobCountryId == 78 && data.controls.question_id.value!=53">
              <mat-label>Please provide description</mat-label>
              <input matInput formControlName="description" maxlength="150">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #loading>
  Loading Criminal history...
</ng-template>